import { render, staticRenderFns } from "./subsidenavbar.vue?vue&type=template&id=8bdef130&"
import script from "./subsidenavbar.vue?vue&type=script&lang=js&"
export * from "./subsidenavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports